// src/hooks/useDataMapping.js

export const detectFormat = (data) => {
  if (data['Código do Termo'] && data['Termo']) {
    return 'TERMINOLOGIA_MATERIAIS_OPME';
  } else if (data['Código do Medicamento'] && data['Nome do Medicamento']) {
    return 'TERMINOLOGIA_MEDICAMENTOS';
  } else if (data['Código do Procedimento'] && data['Nome do Procedimento']) {
    return 'PROCEDIMENTOS_EVENTOS_SAUDE';
  } else if (data['Código CBO'] && data['Nome da Ocupação']) {
    return 'CBO';
  } else if (data['Código Sexo'] && data['Descrição Sexo']) {
    return 'SEXO';
  } else if (
    data['Código do Motivo de Encerramento'] &&
    data['Descrição do Motivo de Encerramento']
  ) {
    return 'MOTIVO_ENCERRAMENTO';
  } else if (
    data['Código do Indicador de Acidente'] &&
    data['Descrição do Indicador de Acidente']
  ) {
    return 'INDICADOR_ACIDENTE';
  } else if (data['Código'] && data['Forma de Envio']) {
    return 'FORMA_ENVIO_ANS';
  } else if (
    data['Código do Tipo de Atendimento'] &&
    data['Descrição do Tipo de Atendimento']
  ) {
    return 'TIPO_ATENDIMENTO';
  } else if (
    data['Código do Tipo de Consulta'] &&
    data['Descrição do Tipo de Consulta']
  ) {
    return 'TIPO_CONSULTA';
  } else if (
    data['Código do Tipo de Internação'] &&
    data['Descrição do Tipo de Internação']
  ) {
    return 'TIPO_INTERNACAO';
  } else if (
    data['Código do Grupo de Procedimentos'] &&
    data['Descrição do Grupo de Procedimentos']
  ) {
    return 'GRUPO_PROCEDIMENTOS';
  } else if (
    data['Código do Regime de Internação'] &&
    data['Descrição do Regime de Internação']
  ) {
    return 'REGIME_INTERNACAO';
  }
  return null;
};

export const mapData = (data) => {
  const detectedFormat = detectFormat(data);

  switch (detectedFormat) {
    case 'TERMINOLOGIA_MATERIAIS_OPME':
      return {
        collection: 'materiais_opme',
        data: {
          id: data['Código do Termo'],
          name: data['Termo'],
          model: data['Modelo'] || 'N/A',
          manufacturer: data['Fabricante'] || 'N/A',
          startDate: data['Data de início de vigência'],
        },
      };
    case 'TERMINOLOGIA_MEDICAMENTOS':
      return {
        collection: 'medicamentos',
        data: {
          id: data['Código do Medicamento'],
          name: data['Nome do Medicamento'],
          activeIngredient: data['Princípio Ativo'] || 'N/A',
          dosage: data['Dosagem'] || 'N/A',
          manufacturer: data['Fabricante'] || 'N/A',
        },
      };
    case 'PROCEDIMENTOS_EVENTOS_SAUDE':
      return {
        collection: 'procedimentos_saude',
        data: {
          id: data['Código do Procedimento'],
          name: data['Nome do Procedimento'],
          description: data['Descrição do Procedimento'] || 'N/A',
          area: data['Área'] || 'N/A',
          chapter: data['Capítulo'] || 'N/A',
          group: data['Grupo'] || 'N/A',
          subgroup: data['Subgrupo'] || 'N/A',
        },
      };
    case 'CBO':
      return {
        collection: 'cbo',
        data: {
          id: data['Código CBO'],
          name: data['Nome da Ocupação'],
          description: data['Descrição da Ocupação'] || 'N/A',
        },
      };
    case 'SEXO':
      return {
        collection: 'sexo',
        data: {
          id: data['Código Sexo'],
          name: data['Descrição Sexo'],
        },
      };
    case 'MOTIVO_ENCERRAMENTO':
      return {
        collection: 'motivo_encerramento',
        data: {
          id: data['Código do Motivo de Encerramento'],
          name: data['Descrição do Motivo de Encerramento'],
        },
      };
    case 'INDICADOR_ACIDENTE':
      return {
        collection: 'indicador_acidente',
        data: {
          id: data['Código do Indicador de Acidente'],
          name: data['Descrição do Indicador de Acidente'],
        },
      };
    case 'FORMA_ENVIO_ANS':
      return {
        collection: 'forma_envio_ans',
        data: {
          id: data['Código'],
          name: data['Forma de Envio'],
        },
      };
    case 'TIPO_ATENDIMENTO':
      return {
        collection: 'tipo_atendimento',
        data: {
          id: data['Código do Tipo de Atendimento'],
          name: data['Descrição do Tipo de Atendimento'],
        },
      };
    case 'TIPO_CONSULTA':
      return {
        collection: 'tipo_consulta',
        data: {
          id: data['Código do Tipo de Consulta'],
          name: data['Descrição do Tipo de Consulta'],
        },
      };
    case 'TIPO_INTERNACAO':
      return {
        collection: 'tipo_internacao',
        data: {
          id: data['Código do Tipo de Internação'],
          name: data['Descrição do Tipo de Internação'],
        },
      };
    case 'GRUPO_PROCEDIMENTOS':
      return {
        collection: 'grupo_procedimentos',
        data: {
          id: data['Código do Grupo de Procedimentos'],
          name: data['Descrição do Grupo de Procedimentos'],
        },
      };
    case 'REGIME_INTERNACAO':
      return {
        collection: 'regime_internacao',
        data: {
          id: data['Código do Regime de Internação'],
          name: data['Descrição do Regime de Internação'],
        },
      };
    default:
      return null;
  }
};
